<template>
  <div class="journey-single-day">
    <div class="journey-day-header">
      <h3>
        <span class="fs-capation-12">Day</span>
        <span class="fs-h5" v-text="dayIndex"></span>
        <span class="desc fs-capation-12">
                <span>預計走 </span>
                <span v-if="parseInt(totalCostMinutes / 60) > 0">
                  <span>{{parseInt(totalCostMinutes / 60)}}</span>
                  <span> 小時 </span>
                </span>
                <span v-if="parseInt(totalCostMinutes % 60) > 0">
                  <span>{{parseInt(totalCostMinutes % 60)}}</span>
                  <span> 分鐘</span>
                </span>
                <span>，於 </span>
                <span v-text="arrivalTime"></span>
                <span> 抵達。</span>
              </span>
      </h3>
    </div>
    <div class="journey-day">
      <div class="journey-head">
        <div class="d-flex justify-content-between">
          <div class="day-start-time-select">
            <span class="fs-capation-12">出發時間</span>
            <select v-model="journeyDepartureTime">
              <option v-for="(item, index) in startTimeOptValues" v-text="item" :value="item" :key="index"></option>
            </select>
          </div>
          <div class="day-start-time-select">
            <span class="fs-capation-12">行走速率</span>
            <select v-model="localClimbRate">
              <option v-for="(item, index) in climbRateOptions" v-text="item.text" :value="item.value" :key="index"></option>
            </select>
          </div>
        </div>
      </div>
      <div class="journey-flex">
        <div class="journey-row" v-for="(item, index) in analyzedJourneyDayData" :key="index">
          <div class="journey-time">
            <div class="milestone-time" v-if="item.type === 'milestone'">
              {{timeStampToTime(item.startTimestamp)}}
            </div>

            <div class="milestone-time" v-if="item.type === 'milestone' && item.duration !== 0 && index !==0 && index !== (analyzedJourneyDayData.length - 1)">
              {{timeStampToTime(item.endTimestamp)}}
            </div>

            <div class="route-time" v-if="item.type === 'route'">
              {{durationFromTimeStamps(item.endTimestamp - item.startTimestamp)}} 分鐘
            </div>
          </div>

          <div class="journey-icon">
            <div class="icon-line up">
            </div>
            <div class="icon-line down">
            </div>

            <div class="icon-milestone" v-if="item.type === 'milestone'">
              <div :class="parseIconClass(item.detail) + ' icon-milestone-content'">
                <img class="mountain" title="三角點" :src="imageSrc.svgMountains" alt="icon"/>
                <img class="parking" title="停車場" :src="imageSrc.svgParking" alt="icon"/>
                <img class="house" title="山屋" :src="imageSrc.svgHouse" alt="icon"/>
                <img class="toilet" title="生態廁所" :src="imageSrc.svgToilet" alt="icon"/>
                <img class="camp" title="可紮營" :src="imageSrc.svgCamp" alt="icon" />
                <img class="entrance" title="入山口" :src="imageSrc.svgWalk" alt="icon"/>
                <img class="water" title="取水點" :src="imageSrc.svgWater" alt="icon"/>
                <img class="wifi" title="訊號點" :src="imageSrc.svgWifi" alt="icon"/>
              </div>
            </div>
          </div>

          <div class="journey-detail">
            <div class="milestone-detail" v-if="item.type === 'milestone'">
              <p class="milestone-name">
                <span>{{item.detail.name}}</span>
                <span class="milestone-height">{{item.detail.height + 'm'}}</span>
              </p>
              <b-dropdown variant="link" toggle-class="milestone-opt text-decoration-none" right no-caret>
                <template #button-content>
                  <span>...</span>
                </template>
                <b-dropdown-item class="text-center" v-if="index !== 0 && index !== (analyzedJourneyDayData.length - 1)" @click="showRestTimeOptModal(index)">設定休息時間</b-dropdown-item>
                <b-dropdown-item class="text-center" v-if="index !== 0 && index !== (analyzedJourneyDayData.length - 1)" @click="changeRestPoint(index, true)">設定為留宿點</b-dropdown-item>
                <b-dropdown-item class="text-center" v-if="index === (analyzedJourneyDayData.length - 1)" @click="changeRestPoint(index, false)">取消留宿點</b-dropdown-item>
                <b-dropdown-item class="text-center" v-if="index !== (analyzedJourneyDayData.length - 1)" @click="removeRoute(index)">加入里程碑</b-dropdown-item>
                <b-dropdown-item class="text-center" @click="removeMilestone(index)">移除里程碑</b-dropdown-item>

              </b-dropdown>
            </div>

            <div class="milestone-detail" v-if="item.type === 'milestone' && item.duration !== 0 && index !==0 && index !== (analyzedJourneyDayData.length - 1)">
              <p class="milestone-name">休息 {{item.duration}} 分鐘</p>
            </div>

            <div class="route-detail" v-if="item.type === 'route'">
              <p class="route-name">
                <span class="route-distance" :title="item.detail.distance + '公尺'"><span class="t-bold">{{(item.detail.distance / 1000.0).toFixed(1)}}</span>km</span>

                <span>
                <span class="t-bold" v-show="item.elevation.heightDiff >= 0"><img style="height: 1em;" :src="imageSrc.svgClimbUp" alt="icon"/></span>
                <span class="t-bold" v-show="item.elevation.heightDiff < 0"><img style="height: 1em;" :src="imageSrc.svgClimbDown" alt="icon"/></span>
                <span class="t-bold">{{Math.abs(item.elevation.heightDiff)}}</span>m
              </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal modal-class="rest-time" ref="diagram-modal" title="設定休息時間" size="sm" centered v-model="showRestModal" @ok="milestoneRestTimeModalSaveClicked">
      <select v-model="milestoneRestTime">
        <option v-for="(item, index) in milestoneRestTimeOpts" :key="index" :value="item" v-text="item + '分鐘'"></option>
      </select>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment/moment";
import {mapActions, mapGetters, mapState} from "vuex";

import svgDirectionsWalk from "@/assets/images/milestone-icon/directions_walk.svg"
import svgRest from "@/assets/images/milestone-icon/new-rest.svg"
import svgDistance from "@/assets/images/milestone-icon/distance.svg"
import svgClimbUp from "@/assets/images/milestone-icon/climb-up.svg"
import svgClimbDown from "@/assets/images/milestone-icon/climb-down.svg"
import svgMountains from "@/assets/images/milestone-icon/mountains.svg"
import svgParking from "@/assets/images/milestone-icon/parking.svg"
import svgHouse from "@/assets/images/milestone-icon/house.svg"
import svgToilet from "@/assets/images/milestone-icon/toilet.svg"
import svgCamp from "@/assets/images/milestone-icon/camp.svg"
import svgWalk from "@/assets/images/milestone-icon/walk.svg"
import svgWater from "@/assets/images/milestone-icon/water.svg"
import svgWifi from "@/assets/images/milestone-icon/wifi.svg"

export default {
  name: 'EditorJourneyDay',
  data() {
    return {
      startTimeOptValues: [],
      arrivalTime: '--:--',
      totalCostMinutes: 0,

      showRestModal: false,
      milestoneRestTimeSettingIndex: -1,
      milestoneRestTime: 15,
      milestoneRestTimeOpts: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 60, 75, 90],

      imageSrc: {
        svgDirectionsWalk: svgDirectionsWalk,
        svgRest: svgRest,
        svgDistance: svgDistance,
        svgClimbUp: svgClimbUp,
        svgClimbDown: svgClimbDown,

        svgMountains: svgMountains,
        svgParking: svgParking,
        svgHouse: svgHouse,
        svgToilet: svgToilet,
        svgCamp: svgCamp,
        svgWalk: svgWalk,
        svgWater: svgWater,
        svgWifi: svgWifi,
      },
    }
  },
  props: {
    journeyDayData: {
      type: Array,
      required: true,
    },
    dayIndex: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapState('journey', ['climbRateArray']),
    ...mapGetters('journey', ['journeyData', 'compiledSplitIndexs', 'compiledJourneyArray', 'isComplete']),

    analyzedJourneyDayData() {
      if (!Array.isArray(this.journeyDayData)) return [];

      return this.journeyDayData.map((item, index, array) => {
        // 只處理 route
        if (item.type !== 'route') {
          return item;
        }

        // 往前找 milestone
        let prevMilestone = null;
        for (let i = index - 1; i >= 0; i--) {
          if (array[i].type === 'milestone') {
            prevMilestone = array[i];
            break;
          }
        }

        // 往後找 milestone
        let nextMilestone = null;
        for (let i = index + 1; i < array.length; i++) {
          if (array[i].type === 'milestone') {
            nextMilestone = array[i];
            break;
          }
        }

        // 找不到前後 milestone → 不處理，原樣回傳
        if (!prevMilestone || !nextMilestone) {
          return item;
        }

        const startHeight = prevMilestone.detail?.height;
        const endHeight = nextMilestone.detail?.height;

        if (
            typeof startHeight !== 'number' ||
            typeof endHeight !== 'number'
        ) {
          return item;
        }

        const heightDiff = endHeight - startHeight;

        let elevationType = 'flat';
        if (heightDiff > 0) elevationType = 'up';
        else if (heightDiff < 0) elevationType = 'down';

        // 回傳「新物件」，不污染原資料
        return {
          ...item,
          elevation: {
            startHeight,
            endHeight,
            heightDiff,
            elevationType,
          },
        };
      });
    },
    journeyDepartureTime: {
      get() {
        return this.timeStampToTime(this.journeyDayData[0].startTimestamp);
      },
      set(timeStr) {
        const ts = this.mergeTimeToTimestamp(this.journeyDayData[0].startTimestamp, timeStr);
        const currentIndex = (this.dayIndex - 1);

        this.setSegmentDepartureTime({
          index: currentIndex,
          leaveTimestamp: ts,
        });
        this.$emit('updated')
        this.refresh();
      },
    },
    localClimbRate: {
      get() {
        return this.climbRateArray[this.dayIndex - 1];
      },
      set(value) {
        const index = this.dayIndex - 1;
        this.setClimbRateAtIndex({
          index: index,
          value: value,
        });
        this.$emit('updated');
        this.refresh();
      }
    },
    climbRateOptions() {
      const options = [];
      for (let val = 0.2; val <= 2; val += 0.1) {
        options.push({
          value: parseFloat(val.toFixed(2)),
          text: Number(val) % 1 === 0 ? String(val) : String(parseFloat(val.toFixed(2)))
        });
      }
      return options;
    },
  },
  watch: {
    journeyDayData() {
      console.log('journeyDayData changed, refreshing...');
      this.refresh();
    }
  },
  async created() {
    let tempT = moment().second(0).minute(0).hour(0);
    for (let i=0;i<(24 * 2);i++){
      this.startTimeOptValues.push(tempT.format('HH:mm'));
      tempT.add(30, 'minutes');
    }
  },
  async mounted() {
    this.refresh();
  },
  beforeDestroy() {
  },
  methods: {
    ...mapActions('journey', ['setSegmentDepartureTime', 'setRestPoint', 'setRestTime', 'setClimbRateAtIndex', 'removeJourneyPoint', 'setClimbRateAtIndex']),

    refresh() {
      this.getDailyLastArrivalTimes();
      this.calculateTotalCostMinutes();
    },
    getDailyLastArrivalTimes() {
      // 防呆：資料不存在或不是陣列或空陣列
      if (!this.journeyDayData || !Array.isArray(this.journeyDayData) || this.journeyDayData.length === 0) {
        this.arrivalTime = '--:--';
        return;
      }

      // 取最後一筆（最晚的）
      const lastSegment = this.journeyDayData[this.journeyDayData.length - 1];
      console.log('lastSegment:' + lastSegment)

      // 防呆 + 型別檢查
      const endTime = Number(lastSegment?.endTimestamp);
      if (isNaN(endTime) || endTime <= 0) {
        this.arrivalTime = '--:--';
        return;
      }

      this.arrivalTime = this.timeStampToTime(endTime);
    },
    calculateTotalCostMinutes() {
      if (!this.journeyDayData || !Array.isArray(this.journeyDayData) || this.journeyDayData.length === 0) {
        this.totalCostMinutes = 0;
        return;
      }

      let totalMinutes = 0;

      this.journeyDayData.forEach(item => {
        // 只處理 type === 'route'
        if (item?.type !== 'route') return;

        const start = Number(item.startTimestamp);
        const end = Number(item.endTimestamp);

        // 嚴格防呆
        if (isNaN(start) || isNaN(end) || end <= start) {
          console.warn('[calculateTotalCostMinutes] 無效的 route 時間範圍', item);
          return;
        }

        const durationMs = end - start;
        const durationMinutes = Math.floor(durationMs / (1000 * 60));

        totalMinutes += durationMinutes;
      })

      this.totalCostMinutes = totalMinutes;
    },
    timeStampToTime(timestamp) {
      if (!timestamp || typeof timestamp !== 'number' || isNaN(timestamp)) {
        return "--:--"
      }

      const date = new Date(timestamp)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}`
    },
    durationFromTimeStamps(t) {
      return parseInt(moment.duration(t).asMinutes());
    },
    parseIconClass(m) {
      if (m.triangle) {
        return 'icon-mountain';
      } else if (m.parking) {
        return 'icon-parking';
      } else if (m.entrance) {
        return 'icon-entrance';
      } else if (m.house) {
        return 'icon-house';
      } else if (m.waterspot === 1) {
        return 'icon-water';
      } else if (m.campable) {
        return 'icon-camp';
        // } else if (m.signal) {
        //   return 'icon-wifi';
      } else if (m.toilet) {
        return 'icon-toilet';
      }
      return 'icon-none';
    },
    mergeTimeToTimestamp(baseTimestamp, timeStr) {
      const [hour, minute] = timeStr.split(':').map(Number);
      return moment(baseTimestamp)
          .hour(hour)
          .minute(minute)
          .second(0)
          .millisecond(0)
          .valueOf();
    },
    removeMilestone(idx) {
      const splitIndex = this.dayIndex - 2
      const index = splitIndex === -1 ? idx : (this.compiledSplitIndexs[splitIndex] + idx)
      this.removeJourneyPoint(index);
      this.$emit('updated');

      this.$gtag.event('CustomClick', {
        event_label: "journeyEditRemoveMilestone",
      });
    },
    removeRoute(idx) {
      const splitIndex = this.dayIndex - 2
      const index = splitIndex === -1 ? idx : (this.compiledSplitIndexs[splitIndex] + idx)
      this.removeJourneyPoint(index+1);
      this.$emit('updated');
      this.$gtag.event('CustomClick', {
        event_label: "journeyEditInsertMilestone",
      });
    },
    startTimeChanged(evt) {
      this.$gtag.event('CustomClick', {
        event_label: "GroupEditDepartTime",
      });
      this.$emit('start-time-changed', evt.target.value);
    },
    showRestTimeOptModal(idx) {
      // this.$gtag.event('CustomClick', {
      //   event_label: "GroupEditSetRestTime",
      // });
      // this.showOptModal = false;
      const splitIndex = this.dayIndex - 2
      const index = splitIndex === -1 ? idx : (this.compiledSplitIndexs[splitIndex] + idx)
      const m = this.compiledJourneyArray[index]
      this.milestoneRestTimeSettingIndex = index;
      this.milestoneRestTime = (m.endTimestamp - m.startTimestamp) / (60 * 1000);
      this.showRestModal = true;
    },
    milestoneRestTimeModalSaveClicked() {
      // const index = this.milestoneRestTimeSettingIndex;
      // const minutes = this.milestoneRestTime
      const restData = {
        index: this.milestoneRestTimeSettingIndex,
        minutes: this.milestoneRestTime,
      }
      this.setRestTime(restData);
      this.$emit('updated')
      this.refresh();
    },
    changeRestPoint(idx, isRestPoint) {
      const splitIndex = this.dayIndex - 2
      const index = splitIndex === -1 ? idx : (this.compiledSplitIndexs[splitIndex] + idx);
      const restPointState = {
        index: index,
        isRestPoint: isRestPoint,
      }
      this.setRestPoint(restPointState);
      const restData = {
        index: index,
        minutes: 0,
      };
      this.setRestTime(restData);
      this.$emit('updated');
      // this.refresh();
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.journey-single-day {
  .journey-day-header {
    border-bottom: 1px solid $color-bk-tp-85;
    h3 {
      display: flex;
      align-items: center;
      gap: 1rem;
    }
  }
}

.journey-day {
  --icon-line-color: #DBDBDB;
  padding: 1.25rem 0;
  background-color: #fff;
}

.t-bold {
  font-weight: 1000;
}

.journey-head {
}

.day-features {
  display: flex;
  justify-content: flex-start;
  /* padding: 0 20px; */
  margin-left: -15px;
  margin-right: -15px;
  margin-bottom: .5em;
  overflow: hidden;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.day-feature {
  flex: 0 0 auto;
  text-align: center;
  padding: 0 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.day-feature-img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.day-feature-img>img {
  /* height: 28px; */
  display: block;
  transform: scale(.8);
  margin-left: auto;
  margin-right: auto;
  /* margin: 0 auto 4px; */
}

.day-feature-img>span {
  font-size: .6rem;
}

.day-feature>p {
  font-size: .7rem;
  margin-bottom: 0;
}

.day-feature .big-text {
  font-size: 1.1rem;
  font-weight: 600;
}

.day-start-time-select {
  margin-bottom: 1.5em;
  font-size: .8rem;
  //color: #ccc;
}

.day-start-time-select>select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='12' width='12' xmlns='http://www.w3.org/2000/svg'><polygon points='0,3 12,3 6,9'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.4em center;
  background-size: 0.7em;
  border-radius: 100px;
  border: 1px solid $color-black;
  padding: .25rem 1rem .25rem .5rem;
  margin-left: .75rem;
}

.journey-flex {
  display: flex;
  flex-wrap: wrap;
  padding-top: 14px;
  /* flex-direction: column; */
}

.journey-head+.journey-flex {
  padding-top: 0;
}

.journey-row {
  flex: 0 0 100%;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
}

/*
.journey-row:first-child a.milestone-opt, .journey-row:last-child a.milestone-opt {
  display: none;
}
*/

.journey-time {
  display: flex;
  flex-direction: column;
  gap: .75rem;
  flex: 0 0 60px;
  text-align: right;
  .milestone-time:not(:first-child) {
    padding-bottom: .75rem;
  }
}

.milestone-time {
  font-size: .9em;
}

.route-time {
  font-size: .9em;
  opacity: .25;
}

.journey-icon {
  flex: 0 0 50px;
  width: 50px;
  min-height: 36px;
  position: relative;
  place-self: stretch;
}

.icon-line {
  position: absolute;
  width: 4px;
  left: 50%;
  transform: translate(-50%, 0);
  background-color: var(--icon-line-color);
}

.icon-line.up {
  top: 0;
  height: 12px;
}

.icon-line.down {
  bottom: 0;
  height: calc(100% - 12px);
}

.journey-row:first-child .icon-line.up {
  display: none;
}

.journey-row:last-child .icon-line.down {
  display: none;
}

.icon-milestone {
  position: absolute;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border: solid 4px var(--icon-line-color);
  /* border: none; */
  top: 12px;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.icon-milestone-content {
  position: absolute;
  width: 24px;
  height: 24px;
  /* background-color: #E5DC81; */
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-milestone-content.icon-none {
  display: none;
}

.icon-milestone-content>img {
  display: none;
  width: 100%;
}

.icon-milestone-content.icon-mountain>img.mountain {
  display: block;
}

.icon-milestone-content.icon-parking>img.parking {
  display: block;
}

.icon-milestone-content.icon-entrance>img.entrance {
  display: block;
}

.icon-milestone-content.icon-water>img.water {
  display: block;
}

.icon-milestone-content.icon-camp>img.camp {
  display: block;
}

.icon-milestone-content.icon-wifi>img.wifi {
  display: block;
}

.icon-milestone-content.icon-toilet>img.toilet {
  display: block;
}

.icon-milestone-content.icon-house>img.house {
  display: block;
}

.icon-milestone-content.icon-house>img.house {
  display: block;
}

.journey-detail {
  display: flex;
  flex-direction: column;
  gap: .375rem;
  flex: 10 1;
  .milestone-detail:not(:first-child) {
    padding-bottom: .75rem;
  }
}

.milestone-detail {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.milestone-name {
  display: flex;
  align-items: center;
  margin: 0;
  font-size: .9em;
  flex: 1 1;
  padding-right: .5em;
}

.milestone-height {
  font-size: .8em;
  padding-left: .5em;
}

.milestone-weather {
  flex: 0 0 110px;
}

.route-detail {
}

.route-name {
  margin: 0;
  font-size: .9em;
  opacity: .25;
}

.route-distance {
  padding-right: 1em;
}

.desc {
  color: $color-bk-tp-50;
}

@media (min-width: 992px) {
  .journey-day {
    padding: 1.25rem .5rem;
  }

  .day-features::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  .day-features::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  .day-features::-webkit-scrollbar-thumb {
    background: #ddd;
  }

  .day-features::-webkit-scrollbar-thumb:hover {
    background: #888;
  }
}
</style>

<style lang="scss">
.journey-single-day {
  .milestone-opt.btn {
    display: flex;
    align-items: center;
    font-size: .9em;
    line-height: 1;
    letter-spacing: 1px;
    padding: 0 10px 10px;
    font-weight: 1000;
    color: #000;
    &:hover {
      color: #000;
    }
  }
}
</style>
